// This file is for code that needs to run before the other imports in main.js resolve and trigger created() in vue singletons

import Vue from 'vue'
import VueStatic from 'vue-static'
Vue.use(VueStatic, { name: 'unreactive' })
